__turbopack_context__.v({
  "avatar": "AvatarCharacter-module__gTcl0q__avatar",
  "avatar-blink": "AvatarCharacter-module__gTcl0q__avatar-blink",
  "avatar-breathe": "AvatarCharacter-module__gTcl0q__avatar-breathe",
  "avatar-cheer": "AvatarCharacter-module__gTcl0q__avatar-cheer",
  "avatar-droop": "AvatarCharacter-module__gTcl0q__avatar-droop",
  "avatar-gasp": "AvatarCharacter-module__gTcl0q__avatar-gasp",
  "avatar-glance": "AvatarCharacter-module__gTcl0q__avatar-glance",
  "avatar-head": "AvatarCharacter-module__gTcl0q__avatar-head",
  "avatar-hop": "AvatarCharacter-module__gTcl0q__avatar-hop",
  "avatar-laugh-body": "AvatarCharacter-module__gTcl0q__avatar-laugh-body",
  "avatar-laugh-head": "AvatarCharacter-module__gTcl0q__avatar-laugh-head",
  "avatar-piece-in": "AvatarCharacter-module__gTcl0q__avatar-piece-in",
  "avatar-tear": "AvatarCharacter-module__gTcl0q__avatar-tear",
  "body": "AvatarCharacter-module__gTcl0q__body",
  "brows": "AvatarCharacter-module__gTcl0q__brows",
  "eyes": "AvatarCharacter-module__gTcl0q__eyes",
  "gaze": "AvatarCharacter-module__gTcl0q__gaze",
  "happy": "AvatarCharacter-module__gTcl0q__happy",
  "head": "AvatarCharacter-module__gTcl0q__head",
  "hovering": "AvatarCharacter-module__gTcl0q__hovering",
  "interactive": "AvatarCharacter-module__gTcl0q__interactive",
  "laugh": "AvatarCharacter-module__gTcl0q__laugh",
  "lean": "AvatarCharacter-module__gTcl0q__lean",
  "moves": "AvatarCharacter-module__gTcl0q__moves",
  "pieceIn": "AvatarCharacter-module__gTcl0q__pieceIn",
  "pressed": "AvatarCharacter-module__gTcl0q__pressed",
  "pupil": "AvatarCharacter-module__gTcl0q__pupil",
  "sad": "AvatarCharacter-module__gTcl0q__sad",
  "tear": "AvatarCharacter-module__gTcl0q__tear",
  "wow": "AvatarCharacter-module__gTcl0q__wow",
});
